/** 手机上的导师：全屏对话。 */
import { createFileRoute } from "@tanstack/react-router";
import { TutorPanel } from "@/features/tutor/TutorPanel";

export const Route = createFileRoute("/tutor")({ component: TutorPage });

function TutorPage() {
  return (
    <div className="h-[calc(100dvh-56px-56px)] md:h-full">
      <TutorPanel />
    </div>
  );
}
